const speakers = [
  {
    name: "Dr. Christian Dimpka",
    institution: "Connecticut Agricultural Experiment Station, New Haven",
    topic: "The Role of Materials in the Management of Agricultural and Environmental Systems"
  },
  {
    name: "Prof. Nian Liu",
    institution: "Georgia Institute of Technology, Atlanta, Georgia, USA",
    topic: "Nanoscale Material Engineering for Rechargeable Aqueous Batteries"
  },
  {
    name: "Prof. Changyou Gao",
    institution: "Zhejiang University, China",
    topic: "Inflammation-modulating biomaterials for tissue repair and regeneration"
  },
  {
    name: "Prof. Mmantsae Diale",
    institution: "University of Pretoria South Africa",
    topic: "Advancing solar energy research with perovskite materials system"
  },
  {
    name: "Prof. Katlego Makgopa",
    institution: "Tshwane University of Technology, South Africa",
    topic: "Exploring the intrinsic properties of a melamine-based covalent organic framework /nitrogen-doped reduced graphene oxide composite for advanced supercapattery applications"
  },
  {
    name: "Prof. Igor Djerdj",
    institution: "Strossmayer University of Osijek, Croatia",
    topic: "High-Entropy Oxides - Promising Multifunctional Materials"
  },
  {
    name: "Prof. Ebenezer Annan",
    institution: "University of Ghana, Accra, Ghana",
    topic: "Thermodynamic Studies of Iron removal from aqueous media using Agrowaste Activated Carbons"
  },
  {
    name: "Dr. Salisu Nasir Nigeria",
    institution: "Department of Applied Chemistry, Federal University of Technology, Babura",
    topic: "Structural Defects and Functional Group Dynamics of Graphene Oxide for Targeted CO₂ Adsorption and Sequestration"
  },
  {
    name: "Koena Moabelo",
    institution: "University of the Western Cape (UWC), South Africa",
    topic: "Nanotechnology-based approaches for efficient anti-obesity drug delivery, bioimaging and therapy"
  },
  {
    name: "Philbert Nshimiyimana",
    institution: "Laboratoire LEMHaD/ Institut 2iE",
    topic: "Towards the development of aluminum-based cellular eco-mortar containing recycled granite sand: thermophysical and mechanical properties"
  },
  {
    name: "Dr. Kudakwashe Jakata",
    institution: "University of the Witwatersrand South Africa",
    topic: "Study of the elastic constants of amorphous GaAs using surface Brillouin scattering"
  },
  {
    name: "Aeriel D. Murphy-Leonard",
    institution: "The Ohio State University, USA",
    topic: "The Influence of Load Ratio on Fatigue Behavior in Additively Manufactured Nickel Aluminum Bronze"
  },
  {
    name: "Dr. Tabiri K. Asumadu",
    institution: "SUNY Polytechnic Institute, USA",
    topic: "Ultra-low solid lubrication of selected metals, enabled by graphene nanocomposite films: mechanistic insights"
  },
  {
    name: "Adria Peterkin",
    institution: "Massachusetts Institute of Technology, USA",
    topic: "Investigating the origins of radiation-affected corrosion of FLiNaK molten salt using hydrogen and helium ion irradiation"
  }
];

export default speakers
